import { useEffect, useState } from 'react';
import { FormField, Select } from 'grommet';
import { HelpWithType } from '@customTypes/enums';
import type { HelpWithProps } from '@customTypes/types';
import type { HelpWIthState } from '@customTypes/stateTypes';

export const HelpWith = (props: HelpWithProps): JSX.Element => {
  const [state, setState] = useState<HelpWIthState>({ name: '', id: '', label: '' });

  useEffect(() => {
    switch (props.selectType) {
      case HelpWithType.Application:
        setState({ name: 'application', id: 'help-with', label: 'What do you need help with?' });
        break;
      case HelpWithType.First:
        setState({ name: 'helpWith', id: 'help-with', label: 'What do you need help with?' });
        break;
      case HelpWithType.FirstInCons:
        setState({ name: 'helpWithInCons', id: 'help-with', label: '' });
        break;
      case HelpWithType.Second:
        setState({ name: 'helpWithSecondary', id: 'help-second', label: props.label || '' });
        break;
      case HelpWithType.Third:
        setState({ name: 'helpWithThird', id: 'help-third', label: props.label || ''});
        break;
      case HelpWithType.Fourth:
        setState({ name: 'helpWithFourth', id: 'help-fourth', label: '' });
        break;
    }
  }, [props.selectType, props.label]);

  return (
    <FormField
      name={state.name}
      htmlFor={state.id}
      label={state.label}
      required
    >
      <Select
        id={state.id}
        name={state.name}
        placeholder="Select"
        options={props.options}
        value={props.value}
        onChange={({ option }) => props.onChange(option)}
      />
    </FormField>
  );
};
